import React, { useEffect, useState } from "react";
import { DashboardLayout } from "../Components";
import { NavLink, useNavigate } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig"
import {MdDeleteOutline,MdOutlineEdit} from "react-icons/md"
import {AiOutlineEye} from "react-icons/ai"
import DataTable from 'react-data-table-component';

const ModuleList = () => {
    let navigate = useNavigate();

    const [Data, SetData] = useState([])
    const GetData = async () => {
        try {
            const responce = await axiosConfig.get("/account/module/")
            SetData(responce.data)
        }
        catch (error) {
            console.log(error)
        }

    }
    useEffect(() => {
        GetData();
    }, [])

    const columns = [
        {
            name: "Id",
            selector: row => row.id,
            sortable: true
        },
        {
            name: "Module Code",
            selector: row => row.module_code,
            sortable: true
        },
        {
            name: "Module Name",
            selector: row => row.module_name,
            sortable: true
        },
        {
            name: "Module Description",
            selector: row => row.module_description,
            sortable: true
        },
        {
            name: "Icon Name",
            selector: row => row.icon_name,
            sortable: true
        },
        {
            name: "Order Number",
            selector: row => row.order_number,
            sortable: true
        },
         {
            name: "ACTIONS",
            selector: row => {
                const HandleEdit = async() => {
                    return navigate(`/dashboard/masters/module/${row.id}/edit`);
                }
                const HandleDelete = async() => {
                    await axiosConfig.delete(`/account/module/${row.id}/`).then(()=>{
                        GetData()
                    }).catch((error)=> {
                        console.log(error)
                    })
                }
                return (
                    <>
                       <div className="row" >
                            <div className="col-4">
                            <AiOutlineEye className="dashboard-tabe-data-actions"  onClick={HandleEdit}/>
                            </div>
                            <div className="col-4">
                                <MdOutlineEdit className="dashboard-tabe-data-actions"  onClick={HandleEdit}/>
                            </div>
                            <div className="col-4">
                                <MdDeleteOutline className="dashboard-tabe-data-actions" onClick={HandleEdit}/>
                            </div>
                        </div>
                    </>
                )

            }
        }
    ]
    return (
        <>
            <DashboardLayout>
                <div className="dashboard-header">
                    <h5 className="dashboard-subtitle">View Module</h5>
                    <NavLink to="/dashboard/masters/module/add" ><button className="btn btn-white">Add New</button></NavLink>
                </div>
                <div className="table-responsive">
                <DataTable columns={columns} data={Data} pagination fixedHeader />
                </div>
                
            </DashboardLayout>
        </>
    )
}
export { ModuleList }